<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="900"
    >
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" color="info" block>Login Log</v-btn>
      </template>

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Login History
        </v-card-title>

        <v-card-text class="px-0 pb-0">
          <v-data-table
            :loading="history.loading"
            :headers="headers"
            :items="history.items"
            :items-per-page="-1"
            hide-default-footer
            fixed-header
            height="calc(100vh - 300px)"
          ></v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="handler"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
  import { API } from '@/utils/api'
  import { mapGetters } from 'vuex'
  import { get } from 'lodash'

  export default {
    props: [],

    data: () => ({
      dialog: false,
      headers: [
        { text: 'IP', value: 'ip', sortable: false },
        { text: 'Login', value: 'login', sortable: false },
        { text: 'User Agent', value: 'user_agent', sortable: false },
        { text: 'Logout', value: 'logout', sortable: false },
      ],

    }),
    computed: {
      ...mapGetters({ activeAccount: 'account/active', history: 'account/loginHistory' }),
    },

    watch: {
      dialog (val) {
        if (val) {
          if (this.history.items.length == 0) {
            this.loadData()
          }
        }
      }
    },

    methods: {
      handler: function (event) {
        this.dialog = false
      },
      loadData: function () {
        this.history.loading = true

        API.call('/$v/account/update_history/login.json', {
          login: this.activeAccount.account.login,
          account_id: this.activeAccount.account.account_id,
        }, this.activeAccount.account).then(resp => {

          this.$store.commit('account/setLoginHistory', get(resp, 'data', []))

          return resp.data
        }).catch(e => {
        }).finally(() => {
          this.history.loading = false
        })

      }
    }

  }
</script>
